export type GenderType = '0' | '1'

export const FEMALE = '1'
export const MALE = '0'

export default [FEMALE, MALE]
